module.exports = __webpack_public_path__ + "static/media/SocialLoopz.603c2407.png";